<template>
  <div>
    <slotBase :bg-grey="true" :loading="isLoading">
      <template v-slot:title>
        <titleBar :header-title="'Top Up'" @back="back" />
      </template>

      <template v-slot:content>
        <div
          class="main-content p-x-20 mt-3 d-flex flex-column justify-content-center"
        >
          <div class="d-flex justify-content-center mb-3">
            <qrImg :qrImgSrc="dataQR" />
          </div>
          <procedureCard />
        </div>
      </template>

      <template v-slot:footer-bottom>
        <bottomBar :topup-page="true" />
      </template>
    </slotBase>
  </div>
</template>

<script>
import slotBase from "@/components/slots/slotBase.vue";
import titleBar from "@/components/design/titleBar.vue";
import bottomBar from "@/components/design/bottomBar.vue";
import procedureCard from "../components/procedureCard.vue";
import qrImg from "../components/qrImg.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "topUp",
  components: {
    slotBase,
    titleBar,
    procedureCard,
    qrImg,
    bottomBar,
  },
  data() {
    return {
      dataQR: "",
      isLoading: false,
    };
  },
  computed: {
    ...mapState("topup", {
      qrImg: "qrImg",
    }),
  },

  methods: {
    ...mapActions({
      getDataQR: "topup/getDataQR",
    }),

    back() {
      this.$router.push({ name: "dashboardUtama" });
    },

    // hexToBinary(hexString) {
    //   const bytes = hexString.math(/.{1,2}/g).map((byte) => parseInt(byte, 16));
    //   console.log(bytes);
    //   console.log(new TextDecoder().decode(new Uint8Array(bytes)));
    //   return new TextDecoder().decode(new Uint8Array(bytes));
    //   // return Buffer.from(hexString, "hex").toString("binary");
    // },
    // binaryToBase64(binaryString) {
    //   console.log(btoa(binaryString));
    //   return btoa(binaryString);
    // },
  },

  mounted() {
    this.isLoading = true;
    this.getDataQR().then((res) => {
      if (res.data.status) {
        // console.log(res);
        this.dataQR = `data:image/png;base64,${res.data.data}`;
        this.isLoading = false;
      }
    });
  },
};
</script>
